import React, {useState} from "react";
import Modal from "react-modal";
import Burn_content_popup_chart from "./Burn-content-popup-chart.js";
import Web3 from "web3";
import Token from '../../abi/UFO.json';
import {providerURL} from "../../utils";
import { sendGetRequest } from '../../../../Helper/helper'; 

const BurnTrackerModal = ({ modalIsOpen, closeModal, volumeDaily, ufoPrice}) => {
  const [burnBalance, setBurnBalance] = useState(0);
  const [todayBurn, setTodayBurn] = useState(0);
  const [burnChartStatus, setBurnChartStatus] = useState(false);

  const handleModalOpen = async () => {
    const web3 = new Web3(providerURL());
    const UFOContract = new web3.eth.Contract(Token.ABI, Token.Contract);
    setBurnBalance(parseInt(await UFOContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18);
    try {
      const response = await sendGetRequest('ufo/historical/burn', 'GET');
      if (response && response.status === 200 && response.data) {
        setTodayBurn(response.data['1Y'] / 365); 
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    // let UFOLiquidity = await getLiquidityData() * 0.01;
    // setTodayBurn(UFOLiquidity);
  };

  const getLiquidityData = async () => {
      try {
        const response = await sendGetRequest('ufo/pairs-volumes/latest/all', 'GET');
        if (response && response.status === 200) {
          let UFOLiquidity = 0;
          response.data.forEach(pair => {
            if (pair.pair_ufo.base_symbol === "UFO") 
            {
              UFOLiquidity += pair.base_liquidity;
            } 
            else if (pair.pair_ufo.qoute_symbol === "UFO") 
            {
              UFOLiquidity += pair.quote_liquidity;
            }
          });
         return UFOLiquidity;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  function calculateBurnedPercentage(burnedSupply) {
    const totalSupply = 999999999051;
    return (burnedSupply / totalSupply) * 100;
  }

  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal" onAfterOpen={handleModalOpen}>
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="UFOSEC popupcenter ">
            <div className="container">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="mb-0 mt-2  w-100 good_times goldFont">UFO Burn Tracker</h2>
            </div>
            <div className="row mt-4">
              <div className="col-sm-12 col-xl-4">
                <div className="subcontent subPad SRTOP ">
                  <div className="d-flex justify-content-between gap-1 align-items-center flex-wrap">
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">Total Burned</span>
                    </div>
                    <div className="iconSR">
                      <img className="img-fluid" src="./images/FireSimple.svg" />
                    </div>
                  </div>
                  <div className="statBottom">
                    <p className="m-0 textgreen">{parseFloat(calculateBurnedPercentage(burnBalance)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% of total supply</p>
                    <div className="dollorVal f26 f34 dollorValRight mt-1">
                      <span className="val">{parseFloat(burnBalance).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                      <span className="dollor2">UFO</span>
                    </div>
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">${parseFloat(burnBalance * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-xl-4 ">
                <div className="subcontent subPad SRTOP ">
                  <div className="d-flex justify-content-between gap-1 align-items-center flex-wrap">
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">Expected Burn in Next 1 Month</span>
                    </div>
                    <div className="iconSR">
                      <img className="img-fluid" src="./images/FireSimple.svg" />
                    </div>
                  </div>
                  <div className="statBottom">
                    <p className="m-0 textgreen">{parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 30))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% of total supply</p>
                    <div className="dollorVal f26 f34 dollorValRight mt-1">
                      <span className="val">{parseFloat(burnBalance + (todayBurn * 30)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                      <span className="dollor2">UFO</span>
                    </div>
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">${parseFloat((burnBalance + (todayBurn * 30)) * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-xl-4 ">
                <div className="subcontent subPad SRTOP ">
                  <div className="d-flex justify-content-between gap-1 align-items-center flex-wrap">
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">Expected Burn in Next 2 Month</span>
                    </div>
                    <div className="iconSR">
                      <img className="img-fluid" src="./images/FireSimple.svg" />
                    </div>
                  </div>
                  <div className="statBottom">
                    <p className="m-0 textgreen">{parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 60))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% of total supply</p>
                    <div className="dollorVal f26 f34 dollorValRight mt-1">
                      <span className="val">{parseFloat(burnBalance + (todayBurn * 60)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                      <span className="dollor2">UFO</span>
                    </div>
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">${parseFloat((burnBalance + (todayBurn * 60)) * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-xl-4 ">
                <div className="subcontent subPad SRTOP ">
                  <div className="d-flex justify-content-between gap-1 align-items-center flex-wrap">
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">Expected Burn in Next 6 Month</span>
                    </div>
                    <div className="iconSR">
                      <img className="img-fluid" src="./images/FireSimple.svg" />
                    </div>
                  </div>
                  <div className="statBottom">
                    <p className="m-0 textgreen">{parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 180))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% of total supply</p>
                    <div className="dollorVal f26 f34 dollorValRight mt-1">
                      <span className="val">{parseFloat(burnBalance + (todayBurn * 180)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                      <span className="dollor2">UFO</span>
                    </div>
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">${parseFloat((burnBalance + (todayBurn * 180)) * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-xl-4 ">
                <div className="subcontent subPad SRTOP ">
                  <div className="d-flex justify-content-between gap-1 align-items-center flex-wrap">
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">Expected Burn in Next 1 Year</span>
                    </div>
                    <div className="iconSR">
                      <img className="img-fluid" src="./images/FireSimple.svg" />
                    </div>
                  </div>
                  <div className="statBottom">
                    <p className="m-0 textgreen">{parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 365))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% of total supply</p>
                    <div className="dollorVal f26 f34 dollorValRight mt-1">
                      <span className="val">{parseFloat(burnBalance + (todayBurn * 365)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                      <span className="dollor2">UFO</span>
                    </div>
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">${parseFloat((burnBalance + (todayBurn * 365)) * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-xl-4 ">
                <div className="subcontent subPad SRTOP ">
                  <div className="d-flex justify-content-between gap-1 align-items-center flex-wrap">
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">Expected Burn in Next 5 Year</span>
                    </div>
                    <div className="iconSR">
                      <img className="img-fluid" src="./images/FireSimple.svg" />
                    </div>
                  </div>
                  <div className="statBottom">
                    <p className="m-0 textgreen">{parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 365 * 5))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% of total supply</p>
                    <div className="dollorVal f26 f34 dollorValRight mt-1">
                      <span className="val">{parseFloat(burnBalance + (todayBurn * 365 * 5)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                      <span className="dollor2">UFO</span>
                    </div>
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span className="">${parseFloat((burnBalance + (todayBurn * 365 * 5)) * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div className="d-flex justify-content-center">
            <button className="p-0 mt-2 mybtn underline text-white" onClick={() => setBurnChartStatus(true)}>
              <span>Burn Chart</span>
            </button>
          </div>
        </div>
      </div>
     </Modal>
     <Burn_content_popup_chart modalIsOpen={burnChartStatus} closeModal={() => setBurnChartStatus(false)}/>
    </>
  );
};

export default BurnTrackerModal;